<!--
 * @ Author: daffy
 * @ Create Time: 2020-04-22 15:45:21
 * @ Modified by: Your name
 * @ Modified time: 2020-09-07 20:07:42
 * @ Description: 首页菜单通过routesRoutes进行控制，先存放在vuex同时存放在session里,还要切换路由？
 -->
<template>
  <section class="tabbar">
    <el-tabs class="fixedTabs" :value="menuActive" @tab-click="handleTabClick" @tab-remove="handleTabRemove">
      <el-tab-pane
        v-for="item in left"
        :key="item.path"
        :label="item.title"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <el-tabs :value="menuActive" @tab-click="handleTabClick" @tab-remove="handleTabRemove">
      <el-tab-pane
        v-for="item in right"
        :key="item.path"
        :closable="item.appType !== 0 || item.meta.closeable"
        :label="item.title"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <p v-show="tabbarp" class="tabbar-p"></p>
  </section>
<!--  <section class="tabbar">
    <el-tabs :value="menuActive" @tab-click="handleTabClick" @tab-remove="handleTabRemove">
      <el-tab-pane :closable="route.appType !== 0 || route.meta.closeable" :label="route.title"
                   v-for="route in menuTree " :key="route.path" :name="route.name">
      </el-tab-pane>
    </el-tabs>
  </section>-->
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'tabbar',
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['menuActive', 'menuTree']),
    left: function () {
      return this.menuTree.filter(function (e, t) {
        return t < 1
      })
    },
    right: function () {
      return this.menuTree.filter(function (e, t) {
        return t > 0
      })
    }
  },
  created () {
  },
  methods: {
    handleTabClick (item) {
      const menuRoute = this.menuTree.find(menu => menu.name === item.name)
      if (menuRoute.children && menuRoute.children.length > 0 && item.name !== this.menuActive) {
        // 如果目标菜单下也有tab栏，就清空tabList。排除点自己
        this.$store.dispatch('clearTabList')
      }
      this.$store.dispatch('setMenuActive', item.name)
    },
    handleTabRemove (index) {
      // 1. 移除与索引对应的 iframe 元素
      const iframes = document.getElementsByTagName('iframe')
      if (iframes && iframes[index]) {
        iframes[index].remove()
      }
      // 2. 清空标签页列表
      this.$store.dispatch('clearTabList')
      // 3. 在下一个 DOM 更新周期中移除菜单项
      this.$nextTick(() => {
        this.$store.dispatch('removeMenu', index)
      })
    }
  }
}
</script>
<style lang="less">
.tabbar {
  margin-left: 64px;
  max-width: 1000px;
  position: relative;
  height: 60px;
  padding-left: 82px
}

.tabbar .fixedTabs {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  max-width: 80px;
  min-width: 80px
}

.tabbar .tabbar-p {
  height: 16px;
  width: 1px;
  background-color: #8d9aa6;
  position: absolute;
  top: 21px;
  left: 154px
}

.tabbar .el-tabs__header {
  margin: 0
}

.tabbar .el-tabs__active-bar {
  display: none
}

.tabbar .el-tabs__item {
  font-size: 16px;
  font-weight: 400;
  padding: 0 24px;
  color: hsla(0, 0%, 100%, .5);
  padding-left: 16px !important
}

.tabbar .el-tabs__item .el-icon-close:hover {
  color: #a5c1dc;
  height: 20px;
  line-height: 20px;
  width: 20px;
  font-size: 14px;
  background-color: #2a4e6f
}

.tabbar .el-tabs__item .el-icon-close {
  font-size: 14px;
  color: #999;
  height: 20px;
  line-height: 20px;
  width: 20px
}

.tabbar .el-tabs__item.is-closable {
  background: hsla(0, 0%, 100%, .05);
  border-radius: 3px;
  color: hsla(0, 0%, 100%, .5);
  font-size: 13px;
  margin-left: 12px;
  height: 34px;
  line-height: 32px;
  padding: 0 11px 0 16px
}

.tabbar .el-tabs__item.is-closable:first-child {
  margin-left: 0
}

.tabbar .el-tabs__item.is-active {
  color: #fff
}

.tabbar .el-tabs__item.is-active.is-closable {
  background: hsla(0, 0%, 100%, .18)
}

.tabbar .el-tabs__nav-wrap:after {
  display: none
}

.tabbar .el-tabs__active-bar {
  bottom: auto;
  top: 0
}

.tabbar .el-tabs .el-tabs__nav-next, .tabbar .el-tabs .el-tabs__nav-prev {
  line-height: 55px
}

.tabbar .el-tabs__item.is-top:last-child {
  padding-right: 11px
}

@media screen and (max-width: 1600px) {
  .tabbar {
    max-width: 800px
  }
}

@media screen and (max-width: 1400px) {
  .tabbar {
    max-width: 600px
  }
}

.tabbar {
  margin-left: 60px;

  .el-tabs {
    &__header {
      margin: 0;
    }

    &__item {
      font-size: 18px;
      font-weight: normal;
      padding: 0 24px;

      .el-icon-close:hover {
        color: #999;
        font-size: 16px;
        padding: 2px;
      }
    }

    &__nav-wrap::after {
      display: none;
    }

    &__active-bar {
      bottom: auto;
      top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/views/layout/TabBar.vue